<template>
    <section class="plugin-home-how-it-works" v-bind:class="{ _full: isFullWidth }">
        <div class="plugin-home-how-it-works__title">
            <plugin-home-common-title v-bind:text="title" />
        </div>

        <div class="plugin-home-how-it-works__container">
<!--            <div></div>-->
            <div class="plugin-home-how-it-works__content">
                <div class="plugin-home-how-it-works__content-menu">
                    <div class="plugin-home-how-it-works__content-menu-arrows">
                        <div class="plugin-home-how-it-works__content-menu-arrows-left"
                             v-bind:class="{ _active: activeIndex > 0 }"
                             ref="prev"
                        >
                            <icon name="caret-left" />
                        </div>
                        <div class="plugin-home-how-it-works__content-menu-arrows-right"
                             v-bind:class="{ _active: activeIndex < items.length - 1 }"
                             ref="next"
                        >
                            <icon name="caret-left" />
                        </div>
                    </div>
                    <div class="plugin-home-how-it-works__content-menu-item"
                         v-for="(item, index) in items"
                         v-bind:key="index"
                         v-bind:class="{ _active: index === activeIndex }"
                         v-on:click="slideTo(index)"
                         v-text="item.menu"
                    />
                </div>
                <div class="plugin-home-how-it-works__content-swiper">
                    <div class="swiper"
                         ref="slider"
                    >
                        <div class="swiper-wrapper">
                            <slot />
                        </div>
                    </div>
                    <div class="swiper-pagination"
                         ref="pagination"
                    ></div>
                </div>
            </div>
<!--            <div></div>-->
        </div>
    </section>
</template>

<script>
// import Swiper from 'swiper/dist/js/swiper';
import utils from '~/utils';

export default {
    name: 'plugin-home-how-it-works-v2',
    props: {
        title: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        activeIndex: 0,
        slider: null,
        sliderMobile: null,
    }),
    computed: {
        isFullWidth() {
            return this.type !== 'HomeHowItWorks2ItemB'; // TODO
        },
    },
    methods: {
        initSlider() {
            if (!this.slider) {
                this.slider = new window.Swiper(this.$refs.slider, {
                    slidesPerView: 'auto',
                    spaceBetween: 12,
                    snapToSlideEdge: true,
                    mousewheel: {
                        forceToAxis: true,
                    },
                    navigation: {
                        nextEl: this.$refs.next,
                        prevEl: this.$refs.prev,
                    },
                    on: {
                        slideChange: (swiper) => {
                            this.activeIndex = swiper.activeIndex;
                        },
                    },
                    pagination: {
                        el: this.$refs.pagination,
                        clickable: true,
                    },
                });
            }
        },
        slideTo(index) {
            this.activeIndex = index;
            this.slider.slideTo(index);
        },
        waitForSwiper() {
            utils.swiper.waitForSwiper(this.initSlider);
        },
    },
    mounted() {
        this.waitForSwiper();
        // utils.dom.addLoadedCallback(this.initSlider);
    },
    beforeDestroy() {
        // utils.dom.removeLoadedCallback(this.initSlider);
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-how-it-works {
    &__title {
        .container-landing();
    }
    &__container {
        .container-landing();

        display: grid;
        // grid-template-columns: 1fr minmax(0, @content-max-width) 1fr;
        grid-template-columns: minmax(0, 100%);
        max-width: 100%;
    }
    /* &._full {
        &__container {
            padding-right: 0 !important;
        }
        &__content {
            grid-column: ~"2 / 4";
        }
    } */
    &__content {
        width: 100%;
        display: flex;
        gap: 48px;
        &-menu {
            display: flex;
            flex-direction: column;
            flex-shrink: 0;
            gap: 24px;
            &-arrows {
                display: flex;
                font-size: 4rem;
                color: @color-gray-main;
                &-right {
                    transform: rotate(180deg);
                }
                &-left,
                &-right {
                    cursor: pointer;
                    &._active {
                        color: @color-gray-darker;
                    }
                }
            }
            &-item {
                .typography-small();

                font-weight: bold;
                color: @color-gray-main;
                cursor: pointer;
                user-select: none;
                &._active {
                    color: @color-gray-darker;
                }
            }
        }
        &-swiper {
            position: relative;
            width: 100%;
            overflow: hidden;
        }
        /deep/ .swiper-pagination {
            display: none;
        }
    }
    &._full &__container {
        padding-right: 0;
    }
    &._full &__content {
        // grid-column: ~"2 / 4";
    }
    @media @media-xl-down {
        &__content {
            flex-direction: column;
            &-menu {
                flex-direction: row;
                overflow-x: auto;
                &-arrows {
                    display: none;
                }
                &-item {
                    flex-shrink: 0;
                }
            }
        }
    }
    @media @media-md-down {
        &._full &__container {
            padding-right: @landing-padding-sm;
        }
        &__content {
            gap: 18px;
            &-menu {
                gap: 12px;
                &-item {
                    .typography-heading();
                }
            }
            &-swiper {
                padding-bottom: 32px;
            }
            /deep/ .swiper-pagination {
                display: block;
            }
            /deep/ .swiper-pagination-bullet {
                border: 1px solid @color-gray-main;
                background-color: white;
                opacity: 1;
            }
            /deep/ .swiper-pagination-bullet-active {
                background-color: @color-gray-main;
            }
        }
    }
}
</style>
